export type KeyboardScope = "modal" | "panel" | "page" | "module" | "global";

export const SCOPE_PRECEDENCE: KeyboardScope[] = ["modal", "panel", "page", "module", "global"];

const selectModalHandlersTopmostFirst = <T extends { scope: KeyboardScope }>(handlersInRegistrationOrder: T[]): T[] =>
	handlersInRegistrationOrder.filter((handler) => handler.scope === "modal").reverse();

const orderHandlersByScope = <T extends { scope: KeyboardScope }>(handlers: T[], modalActive: boolean): T[] => {
	const eligible = modalActive ? selectModalHandlersTopmostFirst(handlers) : handlers;
	return [...eligible].sort((a, b) => SCOPE_PRECEDENCE.indexOf(a.scope) - SCOPE_PRECEDENCE.indexOf(b.scope));
};

export default orderHandlersByScope;
